// const BASE_URL = "http://localhost:3000";

// const BASE_URL = "https://apicivilmantra.aimantra.info";
let BASE_URL = "https://consult-ai.civilmantra.com";
// BASE_URL = "https://ksncfd6v-8000.inc1.devtunnels.ms";
// BASE_URL = 'https://w98v0dbm-8004.inc1.devtunnels.ms'
// Staging url
// BASE_URL = "https://consult-ai-backend.onrender.com";
let BASE_URL_PREBID = "https://consult-ai.civilmantra.com";
// BASE_URL_PREBID = "https://n00nmkv7-8002.inc1.devtunnels.ms";
// BASE_URL_PREBID = "https://0vcgcbh7-8000.inc1.devtunnels.ms/"
let TEST_URL_PREBID = "https://consult-ai.civilmantra.com";
// TEST_URL_PREBID = "https://n00nmkv7-8002.inc1.devtunnels.ms";
// TEST_URL_PREBID = "https://0vcgcbh7-8000.inc1.devtunnels.ms/"
// BASE_URL_PREBID = "https://lr2gx6jv-8000.inc1.devtunnels.ms";

const currentUrl = window.location.href;
const urlParts = currentUrl.split("/");
const FRONTEND_URL = urlParts[0] + `//` + urlParts[2];
let IMAGE_URL = "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";

const AUTH = {
  headers: {
    Authorization: sessionStorage.getItem("access_token")
      ? "Bearer " + sessionStorage.getItem("access_token")
      : null,
    "Content-Type": "application/json",
    accept: "application/json",
  },
};

const AUTHH = {
  headers: {
    Authorization: sessionStorage.getItem("access_token")
      ? "Bearer " + sessionStorage.getItem("access_token")
      : null,
    "Content-Type": "multipart/form-data",
  },
};

export {
  BASE_URL,
  BASE_URL_PREBID,
  TEST_URL_PREBID,
  AUTH,
  AUTHH,
  FRONTEND_URL,
  IMAGE_URL,
};
